import { useMutation } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { downloadVesselRequisitionForVessel } from '../../../common/api/clients/vesselRequisition.api';
import { extractFileName } from '../../../common/helpers/extractFileName.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { RequisitionOptions } from '../../../common/VesselRequisition/types/RequisitionOptions';

export const useVesselRequisitionDownload = () => {
    const { addLoadingToast } = useToasts();
    const { mutateAsync: executeVesselRequisitionForVesselDownload } = useMutation({
        mutationFn: downloadVesselRequisitionForVessel,
    });

    return async (vesselId: string, options: RequisitionOptions) => {
        return addLoadingToast(
            () =>
                executeVesselRequisitionForVesselDownload(
                    { id: vesselId, options },
                    {
                        onSuccess: (response) =>
                            FileDownload(
                                response.data,
                                extractFileName(response.headers['content-disposition'] || '', 'VesselRequisition.xlsx')
                            ),
                    }
                ),
            translate('vessel.requisitionForm.downloading'),
            translate('vessel.requisitionForm.downloadSuccess'),
            translate('vessel.requisitionForm.downloadError')
        );
    };
};
